export default __webpack_public_path__ + "static/media/coffe_icon.fe1b30f2.png";